<template>
    <div class='page'>
        <div class='solgenwrap'>
            <img src="/img/summerprize/solgen.png" >
        </div>
        <div class='prizewrap'>
            <div class='weishop' @click='weishop'>
                <p>直接购买</p>
            </div>
            <div class='winning' @click='winningdetail'>
                <img src="/img/summerprize/Winning.png" >
            </div>
            <div class="turntable">
                <!-- 点击时候转动转盘 指针不转 -->
                <img class="turntable_center" :style="{
                    transform: rotateAngle,
                    transition: rotateTransition === '' ? 'transform 4s ease-in-out' : rotateTransition 
                    }" 
                    src="/img/summerprize/pricecricle.png">
                <img class="turntable_top"  src="/img/summerprize/arrow.png">
                <div class='start' @click="pointer()">
                    <p class='clicktext'>点击抽奖</p>
                    <p class='left'>{{haveChange}}次</p>
                </div>
            </div>
        </div>
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div v-for='(item, index) in arrItem' :key='index' class="swiper-slide">
                    <div class="iSlide">
                        <p>{{item.message}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class='notice'>
            <p>每个账号可通过玩H5获得2次进入大轮盘的机会，后续不再拥有机会。</p>
        </div>
        <div class='tip' v-if='isShowMask'>
            <div class='tipwrap'>
                <img src="/img/summerprize/close.png" class='close' @click='isShowMask = false'>
                <h3 class='title'>中奖啦!</h3>
                <p class='text'>恭喜获得{{prize.awardsName}}，兑换码为{{prize.grantCode}}，请点击下方微店购买链接，找客服兑换哦，请一定截图保存兑换码！</p>
                <div class='sure' @click='weishop'>
                    <p>去兑奖</p>
                </div>
                <div class='sureagain' @click='isShowMask = false'>
                    <p>再抽一次</p>
                </div>
            </div>
        </div>
        <div class='tip' v-if='winningMask'>
            <div class='tipwrap'>
                <img src="/img/summerprize/close.png" class='close' @click='winningMask = false'>
                <h3 class='title'>中奖信息</h3>
                <ul v-if="resultList.length > 0">
                    <li class="result-item" v-for="(item,index) in resultList" :key="index"><span>{{index+1}}. </span>{{item.awardsName}},兑换码为:{{item.grantCode}}</li>
                </ul>
                <p v-else class="no-xinxi">暂无抽奖信息</p>
                <p class="explain">*每单只可使用一张优惠券，抽奖规则解释权归韵文博鉴微店所有。</p>
            </div>
        </div>
        <!--toast-->
        <div class="toast" v-show="toastShow">
            {{toastText}}
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import services from './services';

export default {
    data() {
        return {
            luckflag: true,
            toastShow: false,
		    rotateAngle: 0, // 将要旋转的角度
            startRotatingDegree: 0, // 初始旋转角度
            rotateTransition:'',// 控制过渡效果
            click_flag: true, // 是否可以旋转抽奖
            isShowMask: false, // 中奖弹框
            toastText: '', //提示弹框文字
            winningMask: false,
            prize: {
                awardsName: '',
                grantCode: '',
                usageCount: '',
                awardsKey: ''
            },
            haveChange: 0,
            resultList: [],
            arrItem: [
                {
                    message: '微信用户啾啾球获得了遮阳伞'
                },
                {
                    message: '微信用户陈大师jack获得了15元优惠券'
                },
                {
                    message: '微信用户小炎要加油获得了夏日冰垫'
                },
                {
                    message: '微信用户yuliyuli获得了遮阳伞'
                },
                {
                    message: '微信用户Rachel获得了文创笔袋'
                }
            ],
        };
    },
    mounted() {
        /* eslint-disable no-new */
        new Swiper('.swiper-container', {
            loop: true,
            direction : 'vertical',
            speed: 2000,
            autoplay : true
        });
        // 获取剩余抽奖次数
        this.getActcivityFancy();
    },
    computed: {
        userInfo() {
            return this.$store.state.system.userInfo || {};
        }
    },
    methods: {
        // 点击指针
        pointer() {
            // 抽奖函数
            this.getlotteryPrizeFun();
        },
        // 转动
        rotate(prize) {
            // 目前是只转动转盘
            if (!this.click_flag) {
                return;
            };
            const type = 0; // 默认为 0  转盘转动
            const randCircle = 12; // 附加多转几圈，2-3
            const duringTime = 4; // 默认为 5s
            let rotateAngle = '';
            switch (prize.awardsKey) {
                case 'pencap':
                    rotateAngle = randCircle * 360 + 330;
                    break;
                case 'coupon15':
                    rotateAngle = randCircle * 360 + 270;
                    break;
                case 'umbrella':
                    rotateAngle = randCircle * 360 + 210;
                    break;
                case 'pajamas':
                    rotateAngle = randCircle * 360 + 150;
                    break;
                case 'coupon5':
                    rotateAngle = randCircle * 360 + 90;
                    break;
                case 'icepad':
                    rotateAngle = randCircle * 360 + 30;
                    break;
            }
            this.click_flag = false; // 旋转结束前，不允许再次触发
            if (type === 0) {
                // 转动盘子
                const rotateAngledeg = this.startRotatingDegree + rotateAngle - this.startRotatingDegree % 360; // 将要旋转的角度
                this.startRotatingDegree = rotateAngledeg; // 改变初始旋转的角度
                this.rotateAngle = "rotate(" + rotateAngledeg + "deg)"; // 真正控制转动角度
                // 旋转结束后允许再次触发
                setTimeout(() => {
                    this.click_flag = true;
                    this.gameOver(prize);
                }, duringTime * 1000 + 200);
            }
        },
        // 游戏结束
        gameOver() {
            // 游戏结束,重置旋转初始位置
            this.rotateAngle = 'rotate(' + this.rotateAngle + 'deg)'; // 真正控制转动角度的,从上个指针的位置开始下一次的抽奖
            this.rotateTransition = 'transform 0.05s ease-in-out'; // 控制转动过渡效果的
            setTimeout(() => {
                this.rotateTransition = '';
            }, 100);
            // 中奖弹窗提示
            this.isShowMask = true;
            this.winAward = true;
            // 更新抽奖次数
            this.getActcivityFancy();
        },
        // 请求活动页面数据
        getActcivityFancy() {
            services.getchance({
                activityId: 6,
                userId: sessionStorage.getItem('openId')
            }).then(res => {  
                if (res&&res.returnCode === 0) {
                    this.haveChange = res.data.lotteryCount || 0;
                }
            }).catch(() => {});
        },
        // 请求点击抽奖数据,中奖操作
        getlotteryPrizeFun() {
            services.lottery({
                activityId: 6,
                userId: sessionStorage.getItem('openId')
            }).then(res => {  
                if (res&&res.returnCode === 0) {
                    this.prize = res.data.data;
                    this.rotate(this.prize);
                }
                else {
                    this.toast(res.returnMessage);
                }
            }).catch(() => {});
        },
        weishop() {
            this.isShowMask = false;
            /* eslint-disable-next-line */
            window._hmt.push(['_trackEvent', '市场夏日抽奖活动-跳转微店', '夏日抽奖活动-跳转微店点击量 ', window.location.href]); // 百度统计
            window.location.href = 'https://weidian.com/?userid=1612917312&spider_token=3304';
        },
        maskdisapear() {
            this.isShowMask = false;
        },
        // 警示弹框
        toast(str) {
            this.toastText = str;
            this.toastShow = true;
            setTimeout(() => {
                this.toastShow = false;
            }, 1000);
        },
        // 显示中奖信息
        winningdetail() {
            this.winningMask = true;
            services.lotteryResult({
                activityId: 6,
                userId: sessionStorage.getItem('openId'),
                pageIndex: 1,
                pageSize: 10,
                status: 99
            }).then(res => {  
                if (res&&res.returnCode === 0) {
                    this.resultList = res.data.list;
                }
                else {
                    this.toast(res.returnMessage);
                }
            }).catch(() => {});
        }
    }
};
</script>

<style lang='stylus' scoped>
@import "../../../node_modules/swiper/dist/css/swiper.min.css";
.page
    size 100%
    background url('/img/summerprize/summerprizebg.jpg') 0 0/100% 100% no-repeat
    .solgenwrap
        width 100%
        display flex
        flex-direction row
        justify-content center
        padding-top 0.4rem
    .winning
        position absolute
        right 0
        top 7%
    .prizewrap
        display flex
        flex-direction column
        align-items center
        .weishop
            size 2rem 0.6rem
            background url('/img/summerprize/bgc.png') 0 0/100% 100% no-repeat
            display flex
            flex-direction row
            align-items center
            justify-content center
            position absolute
            top 15%
            p
                font-size 0.28rem
                color red
        .turntable
            position relative
            display flex
            flex-direction column
            align-items center
            justify-content center
            margin-top 25%
            .turntable_center
                transform-origin 50% 50%
            .turntable_top
                position absolute
                top -6%
                left 50%
                transform translateX(-50%)
            .start
                position absolute
                background url('/img/summerprize/btn.png') 0 0/100% 100% no-repeat
                display flex
                flex-direction column
                align-items center
                justify-content center
                size 2.05rem
                .clicktext
                    width 0.8rem
                    display block
                    text-align center
                    font-size 0.32rem
                    color red
                .left
                    font-size 0.26rem
                    color red
    .swiper-container
        width 65%
        border 2px solid #f9cf93
        background-color #1480cb
        border-radius 0.2rem
        position absolute
        bottom 5%
        margin-left 17.5%
        .swiper-wrapper
            height 0.5rem
        p
            font-size 0.25rem
            line-height 0.5rem
            color #fff
            text-align center
    .notice
        position absolute
        bottom 2%
        width 100%
        display flex
        flex-direction row
        justify-content center
        p
            font-size 0.2rem
            color #3b7253
.tip
    size 100%
    position fixed
    top 0
    left 0
    background-color rgba(0, 0, 0, 0.7)
    display flex
    flex-direction column
    align-items center
    justify-content center
    z-index 10
    .close
        position absolute
        width 0.3rem
        right 0.15rem
        top 0.15rem
    .tipwrap
        size 80% 6.3rem
        background-color #fff
        display flex
        flex-direction column
        align-items center
        justify-content center
        position relative
        background url('/img/summerprize/tips.png') 0 0/100% 100% no-repeat
        ul
            width 83%
            position absolute
            top 1.5rem
            .result-item
                box-sizing border-box
                padding-left 0.2rem
                font-size 0.24rem
                line-height 0.4rem
                span
                    color #f66
        .no-xinxi
            font-size 0.26rem
            text-align center
        .explain
            width 83%
            position absolute
            bottom 0.25rem
            font-size 0.2rem
            color #ff6666
        .title
            font-size 0.32rem
            margin-bottom 0.2rem
            color #36bac6
            position absolute
            top 9%
        .text
            display block
            width 75%
            font-size 0.3rem
            color #36bac6
            text-align justify
            line-height 0.4rem
            margin-top -0.8rem
        .sure
            font-size 0.3rem
            display block
            width 1.3rem
            height 0.5rem
            position absolute
            bottom 15%
            background url('/img/summerprize/sure.png') 0 0/100% 100% no-repeat
            border-radius 0.2rem
            color #fff
            display flex
            flex-direction row
            align-items center
            justify-content center
        .sureagain
            font-size 0.3rem
            display block
            width 1.3rem
            height 0.5rem
            position absolute
            bottom 30%
            background url('/img/summerprize/sure.png') 0 0/100% 100% no-repeat
            border-radius 0.2rem
            color #fff
            display flex
            flex-direction row
            align-items center
            justify-content center
.toast
    position fixed
    z-index 2000
    left 50%
    top 50%
    transition all .5s
    text-align center
    border-radius 5px
    color #FFF
    font-size 0.28rem
    background rgba(17, 17, 17, 0.7)
    padding 0.15rem 0.3rem
    transform translateX(-50%) translateY(-50%)
</style>
